export const chatContentResources = {
  "zh-CN": {
    chat: {
      messageActions: {
        copy: "复制",
        copied: "已复制",
        regenerate: "重新生成",
        like: "点赞",
        unlike: "取消点赞",
        dislike: "点踩",
        undislike: "取消点踩",
      },
      content: {
        assistantIdentity: {
          directConversation: "直接对话",
          loadFailed: "智能体加载失败",
          loading: "正在加载智能体…",
          unavailable: "智能体不可用",
        },
        documentCanvas: {
          loadingTask: "正在加载文档任务",
          outlineReview: "大纲待确认",
          completed: "已完成",
          generating: "生成中",
          generatingProgress: "生成中 {{completed}}/{{total}}",
          preparing: "准备中",
          export: "导出",
          upgradeTask: "升级正式任务",
          distillWriting: "沉淀写法",
          distillTooltip: "把本文写法提炼为公司候选，供管理员确认后生效",
          confirmFailed: "确认失败",
          downloadFailed: "产物下载失败",
          upgraded: "已升级为正式任务，可在文档生成列表中查看",
          upgradeFailed: "升级失败",
          distilledCount_one: "已提炼 {{count}} 条写法候选，待管理员在「写作风格页」确认",
          distilledCount_other: "已提炼 {{count}} 条写法候选，待管理员在「写作风格页」确认",
          distilledEmpty: "未能提炼出可用写法候选",
          distillFailed: "沉淀失败",
          loadingOutline: "正在生成大纲…",
          confirmAndGenerate: "确认并生成",
          generationFailed: "生成失败：{{error}}",
          unknownError: "未知错误",
        },
        artifactPanel: {
          downloadUrlFailed: "获取产物下载地址失败",
          downloadFailed: "产物下载失败",
          loadFailed: "产物加载失败，请尝试下载后查看。",
          noConversationArtifacts: "本会话暂无生成产物。",
          noRunArtifacts: "发起任务后，Agent 产出的文件会出现在这里。",
          generationInProgress: "任务生成中，完成后可打开产物",
          title: "产物",
          unknownType: "未知类型",
          loading: "正在加载…",
          download: "下载 {{name}}",
          files: "文件",
          uploaded: "上传",
          noConversationFiles: "本会话暂无文件",
          view: "查看",
          assistantReply: "回复智能体：{{name}}",
          defaultAssistantName: "AI 助手",
          assistantFallback: "智能体",
          customInputAria: "{{label}}，自己填写",
          debug: {
            title: "调试台",
            workspace: "{{name}} 调试工作区",
            currentDraft: "当前草稿",
            publishedVersion: "发布版本 v{{version}}",
            replyLabel: "第 {{index}} 条 · {{question}}",
            replyFallback: "回复",
            running: "执行中",
            failed: "失败",
            stopped: "已停止",
            completed: "已结束",
            pending: "待测试",
            detailsOnly: "详细记录（仅后续请求）",
            details: "详细记录",
            detailsHint: "仅后续请求生效，不增加模型调用",
            staleDraft: "草稿已变更",
            statusAria: "运行状态：{{status}}。查看实际模型",
            actualModel: "发送问题后显示实际模型与版本",
            nextUsesDraft: "下一次发送将使用新草稿创建测试。",
            newTest: "新建测试",
            newTestHint: "新建测试，保留未发送文字",
            taskRecords: "任务记录",
            formalTaskRecords: "正式任务记录",
            backToConfig: "返回配置",
            fullscreen: "全屏调试",
            debugTarget: "调试对象",
            conversation: "对话",
            replyCount_one: "{{count}} 条回复",
            replyCount_other: "{{count}} 条回复",
            notTested: "尚未测试",
            debugContent: "调试内容",
            answer: "回答",
            callDetails: "调用详情",
            inspectReply: "查看回复的调用详情",
            noReply: "尚无回复",
            latest: "回到最新",
            debugConversation: "调试对话",
            userHint: "输入问题，验证智能体的回答与调用过程。",
            inspectCall: "查看调用",
            currentReply: " · 当前回复",
            testQuestion: "输入测试问题",
            testOperations: "测试操作",
            submitTask: "提交正式任务",
            sendShortcut: "Ctrl / ⌘ + Enter 发送",
            stopDebug: "停止调试",
            sendTestQuestion: "发送测试问题",
            replyCallDetails: "当前回复调用详情",
          },
        },
        directArtifact: {
          loadFailed: "产物加载失败",
          downloadFailed: "产物下载失败",
          generating: "正在生成{{format}}…",
          webpage: "网页",
          spreadsheet: "表格",
          loadingPreview: "正在加载预览…",
          spreadsheetReady: "Excel 产物已生成，可下载或在线编辑",
          download: "下载",
          onlineEdit: "在线编辑",
        },
        section: {
          rewriteSucceeded: "「{{title}}」已改写",
          rewriteFailed: "改写失败",
          rewrite: "改写",
          cancel: "取消",
          instructionHint: "对「{{title}}」说点什么，例如：压缩到半页，只讲结论 / 换个角度重写",
          rewritePlaceholder: "改写指令…",
          rewriting: "正在改写…",
          generating: "生成中…",
          waiting: "等待生成",
        },
        documentMode: {
          directExcel: "Excel 直出",
          directWebpage: "网页直出",
          nextMessageGenerates: "下一条消息将直接生成",
          documentMode: "文档模式",
          genrePlaceholder: "选择体裁",
          assistantName: "智能体：{{name}}",
          exit: "退出",
        },
        browser: {
          htmlPreview: "HTML 预览",
          webpagePreview: "网页预览",
          refresh: "刷新",
          restore: "还原",
          maximize: "最大化",
          openInNewWindow: "新窗口打开",
          closePreview: "关闭预览",
          loading: "正在加载网页",
        },
        markdown: {
          imageUnavailable: "图片暂不可读取。",
          retry: "重试",
          viewImageSource: "查看图片来源",
          imageFallback: "聊天图片",
          codeLanguage: "代码",
          codePreview: "预览",
          copyCode: "复制代码",
          codeCopied: "已复制代码",
        },
        attachment: {
          imagePreview: "图片预览",
          imagePreviewAlt: "预览图片",
          openImagePreview: "预览图片 {{filename}}",
          file: "文件",
          pageCount_one: "{{count}} 页",
          pageCount_other: "{{count}} 页",
          downloadFile: "下载 {{filename}}",
          expired: "{{filename}}（已过期）",
        },
        webSources: {
          searchResults_one: "搜索来源（{{count}}）",
          searchResults_other: "搜索来源（{{count}}）",
          showMore: "查看更多（{{count}}）",
          searchResult: "搜索结果",
        },
        spec: {
          revokeFailed: "撤销失败，请到写作风格页重试",
          revoked: "已撤销记忆：「{{content}}」",
          companyPending: "已提交公司规范候选 · 待管理员审核",
          personalActive: "已记入「我的规范」 · 即时生效",
          manage: "管理",
          revoke: "撤销",
        },
        proposal: {
          appliedSaved: "提案已采纳保存",
          submitted: "已提交整理提案：{{summary}}",
          pendingCount_one: "{{count}} 篇待确认",
          pendingCount_other: "{{count}} 篇待确认",
          fieldCount_one: "{{count}} 个字段",
          fieldCount_other: "{{count}} 个字段",
          tagCount_one: "{{count}} 个标签",
          tagCount_other: "{{count}} 个标签",
          sampleSeparator: "、",
          samplesRemaining: "等 {{count}} 篇",
          appliedToast_one: "已采纳 {{count}} 篇提案并保存",
          appliedToast_other: "已采纳 {{count}} 篇提案并保存",
          appliedWithRestricted_one: "已采纳 {{count}} 篇提案并保存；另有 {{restrictedCount}} 篇无编辑权限，需由有权限成员确认",
          appliedWithRestricted_other: "已采纳 {{count}} 篇提案并保存；另有 {{restrictedCount}} 篇无编辑权限，需由有权限成员确认",
          needsEditorPermission: "提案需要文件的编辑权限，请由有权限的成员在文档中心确认",
          noneToApply: "没有可采纳的提案（可能已确认或已过期）",
          readFailed: "提案读取失败，请到文档中心确认",
          applying: "采纳中…",
          acceptAll: "全部采纳",
          confirmByField: "逐字段确认",
        },
        message: {
          cancelEdit: "取消",
          sendEdit: "发送",
          editMessage: "编辑消息",
          previousVersion: "上一版本",
          nextVersion: "下一版本",
          generating: "正在生成…",
          unknownFile: "未知文件",
          genericDocument: "文档",
          fileEvidenceSummary: "本次附件阅读取得的资料",
        },
        systemFeedback: {
          replyGenerationFailed: "回复生成失败，请稍后重试",
          errorContext: { generateReply: "生成回复" },
          feedbackFailed: "反馈提交失败，请重试",
          modelSwitchFailed: "切换模型失败，已恢复为原模型",
          dialogueSwitchFailed: "切换未完成，请重试；输入内容已保留。",
          dialogueInterrupted: "补充过程已中断，请核对已保存信息后继续；输入内容已保留。",
        },
        dialogueStatus: {
          paused: "已暂停补充，可以先聊其他问题。说“继续补充”可回到原任务。",
          resumed: "已回到原来的补充问题，请继续。",
        },
        videoPromotion: {
          selectSingleKnowledgeBase: "请先在“添加资料”中只选择一个知识库，再加入视频语料",
          added: "「{{filename}}」已加入知识库，并可在文件中心复用",
          failed: "「{{filename}}」加入知识库失败",
          unknownError: "未知错误",
        },
        attachmentUpload: {
          tooLarge: "「{{filename}}」超过 20MB；大文件请前往文件中心 → 知识库 → 检索问答",
          unsupportedType: "「{{filename}}」不支持的文件类型：{{type}}",
          unknownType: "未知",
        },
        documentModeFeedback: {
          directTaskFailed: "直出任务创建失败",
          directTaskCreation: "创建直出任务",
          taskFailed: "文档任务创建失败",
          taskCreation: "创建文档任务",
          selectGenreTemplate: "请先选择体裁模板",
        },
        versionPicker: {
          current: "当前",
          downloadFailed: "版本下载失败",
          downloadVersion: "下载 v{{version}}",
        },
      },
    },
  },
  "en-US": {
    chat: {
      messageActions: {
        copy: "Copy",
        copied: "Copied",
        regenerate: "Regenerate",
        like: "Like",
        unlike: "Remove like",
        dislike: "Dislike",
        undislike: "Remove dislike",
      },
      content: {
        assistantIdentity: {
          directConversation: "Direct conversation",
          loadFailed: "Could not load the agent",
          loading: "Loading agent…",
          unavailable: "Agent unavailable",
        },
        documentCanvas: {
          loadingTask: "Loading document task",
          outlineReview: "Outline awaiting confirmation",
          completed: "Completed",
          generating: "Generating",
          generatingProgress: "Generating {{completed}}/{{total}}",
          preparing: "Preparing",
          export: "Export",
          upgradeTask: "Upgrade to a full task",
          distillWriting: "Save writing style",
          distillTooltip: "Extract this document's writing style as a company candidate for an administrator to review",
          confirmFailed: "Confirmation failed",
          downloadFailed: "Artifact download failed",
          upgraded: "Upgraded to a full task. Find it in the document generation list.",
          upgradeFailed: "Upgrade failed",
          distilledCount_one: "Extracted {{count}} writing style candidate. An administrator can review it on the Writing Styles page.",
          distilledCount_other: "Extracted {{count}} writing style candidates. An administrator can review them on the Writing Styles page.",
          distilledEmpty: "No usable writing style candidates could be extracted",
          distillFailed: "Could not save writing style",
          loadingOutline: "Generating outline…",
          confirmAndGenerate: "Confirm and generate",
          generationFailed: "Generation failed: {{error}}",
          unknownError: "Unknown error",
        },
        artifactPanel: {
          downloadUrlFailed: "Could not get the artifact download URL",
          downloadFailed: "Artifact download failed",
          loadFailed: "Artifact loading failed. Try downloading it instead.",
          noConversationArtifacts: "This conversation has no generated artifacts yet.",
          noRunArtifacts: "Files produced by the Agent will appear here after you start a task.",
          generationInProgress: "The task is still running. Artifacts will be available when it finishes.",
          title: "Artifacts",
          unknownType: "Unknown type",
          loading: "Loading…",
          download: "Download {{name}}",
          files: "Files",
          uploaded: "Uploads",
          noConversationFiles: "This conversation has no files yet.",
          view: "View",
          assistantReply: "Reply from {{name}}",
          defaultAssistantName: "AI assistant",
          assistantFallback: "Agent",
          customInputAria: "{{label}}, enter a custom value",
          debug: {
            title: "Debug console",
            workspace: "{{name}} debug workspace",
            currentDraft: "Current draft",
            publishedVersion: "Published version v{{version}}",
            replyLabel: "Reply {{index}} · {{question}}",
            replyFallback: "Reply",
            running: "Running",
            failed: "Failed",
            stopped: "Stopped",
            completed: "Completed",
            pending: "Not tested",
            detailsOnly: "Detailed logs (future requests only)",
            details: "Detailed logs",
            detailsHint: "Applies only to future requests and adds no model calls",
            staleDraft: "Draft changed",
            statusAria: "Run status: {{status}}. View actual model",
            actualModel: "The actual model and version appear after you send a question",
            nextUsesDraft: "The next request will create a test with the updated draft.",
            newTest: "New test",
            newTestHint: "Start a new test and keep unsent text",
            taskRecords: "Task records",
            formalTaskRecords: "Formal task records",
            backToConfig: "Back to configuration",
            fullscreen: "Full-screen debug",
            debugTarget: "Debug target",
            conversation: "Conversation",
            replyCount_one: "{{count}} reply",
            replyCount_other: "{{count}} replies",
            notTested: "Not tested yet",
            debugContent: "Debug content",
            answer: "Answer",
            callDetails: "Call details",
            inspectReply: "View call details for this reply",
            noReply: "No replies yet",
            latest: "Go to latest",
            debugConversation: "Debug conversation",
            userHint: "Enter a question to check the Agent's response and tool calls.",
            inspectCall: "View call",
            currentReply: " · Current reply",
            testQuestion: "Enter a test question",
            testOperations: "Test actions",
            submitTask: "Submit formal task",
            sendShortcut: "Press Ctrl / ⌘ + Enter to send",
            stopDebug: "Stop debugging",
            sendTestQuestion: "Send test question",
            replyCallDetails: "Call details for current reply",
          },
        },
        directArtifact: {
          loadFailed: "Artifact failed to load",
          downloadFailed: "Artifact download failed",
          generating: "Generating {{format}}…",
          webpage: "webpage",
          spreadsheet: "spreadsheet",
          loadingPreview: "Loading preview…",
          spreadsheetReady: "Excel artifact is ready to download or edit online",
          download: "Download",
          onlineEdit: "Edit online",
        },
        section: {
          rewriteSucceeded: "“{{title}}” was rewritten",
          rewriteFailed: "Rewrite failed",
          rewrite: "Rewrite",
          cancel: "Cancel",
          instructionHint: "Describe what to change in “{{title}}”, for example: shorten it to half a page and focus on conclusions / rewrite it from another angle",
          rewritePlaceholder: "Rewrite instructions…",
          rewriting: "Rewriting…",
          generating: "Generating…",
          waiting: "Waiting to generate",
        },
        documentMode: {
          directExcel: "Generate Excel directly",
          directWebpage: "Generate webpage directly",
          nextMessageGenerates: "The next message will generate it directly",
          documentMode: "Document mode",
          genrePlaceholder: "Select a genre",
          assistantName: "Agent: {{name}}",
          exit: "Exit",
        },
        browser: {
          htmlPreview: "HTML preview",
          webpagePreview: "Webpage preview",
          refresh: "Refresh",
          restore: "Restore",
          maximize: "Maximize",
          openInNewWindow: "Open in new window",
          closePreview: "Close preview",
          loading: "Loading webpage",
        },
        markdown: {
          imageUnavailable: "Image is temporarily unavailable.",
          retry: "Retry",
          viewImageSource: "View image source",
          imageFallback: "Chat image",
          codeLanguage: "Code",
          codePreview: "Preview",
          copyCode: "Copy code",
          codeCopied: "Code copied",
        },
        attachment: {
          imagePreview: "Image preview",
          imagePreviewAlt: "Preview image",
          openImagePreview: "Preview image {{filename}}",
          file: "File",
          pageCount_one: "{{count}} page",
          pageCount_other: "{{count}} pages",
          downloadFile: "Download {{filename}}",
          expired: "{{filename}} (expired)",
        },
        webSources: {
          searchResults_one: "Search source ({{count}})",
          searchResults_other: "Search sources ({{count}})",
          showMore: "Show {{count}} more",
          searchResult: "Search result",
        },
        spec: {
          revokeFailed: "Could not revoke. Try again from Writing Styles.",
          revoked: "Memory revoked: “{{content}}”",
          companyPending: "Company standard submitted · awaiting administrator review",
          personalActive: "Added to My Standards · active immediately",
          manage: "Manage",
          revoke: "Revoke",
        },
        proposal: {
          appliedSaved: "Proposal accepted and saved",
          submitted: "Organization proposal submitted: {{summary}}",
          pendingCount_one: "{{count}} pending",
          pendingCount_other: "{{count}} pending",
          fieldCount_one: "{{count}} field",
          fieldCount_other: "{{count}} fields",
          tagCount_one: "{{count}} tag",
          tagCount_other: "{{count}} tags",
          sampleSeparator: ", ",
          samplesRemaining: "and {{count}} more",
          appliedToast_one: "Accepted and saved {{count}} proposal",
          appliedToast_other: "Accepted and saved {{count}} proposals",
          appliedWithRestricted_one: "Accepted and saved {{count}} proposal; {{restrictedCount}} more need confirmation by a member with edit access",
          appliedWithRestricted_other: "Accepted and saved {{count}} proposals; {{restrictedCount}} more need confirmation by a member with edit access",
          needsEditorPermission: "These proposals require file edit access. Ask a member with access to confirm them in Document Center.",
          noneToApply: "No proposals are available to accept. They may already be confirmed or expired.",
          readFailed: "Could not load proposals. Review them in Document Center.",
          applying: "Accepting…",
          acceptAll: "Accept all",
          confirmByField: "Review each field",
        },
        message: {
          cancelEdit: "Cancel",
          sendEdit: "Send",
          editMessage: "Edit message",
          previousVersion: "Previous version",
          nextVersion: "Next version",
          generating: "Generating…",
          unknownFile: "Unknown file",
          genericDocument: "Document",
          fileEvidenceSummary: "Material read from this attachment",
        },
        systemFeedback: {
          replyGenerationFailed: "Could not generate a reply. Try again later.",
          errorContext: { generateReply: "generate a reply" },
          feedbackFailed: "Could not submit feedback. Try again.",
          modelSwitchFailed: "Could not switch models. Restored the previous model.",
          dialogueSwitchFailed: "Could not switch modes. Try again; your input has been kept.",
          dialogueInterrupted: "The follow-up was interrupted. Check the saved information before continuing; your input has been kept.",
        },
        dialogueStatus: {
          paused: "Follow-up paused. You can ask something else; say “continue follow-up” to return to the original task.",
          resumed: "Back to the original follow-up question. Please continue.",
        },
        videoPromotion: {
          selectSingleKnowledgeBase: "Select one knowledge base in “Add materials” before adding this video as source material.",
          added: "“{{filename}}” was added to the knowledge base and can be reused in File Center.",
          failed: "Could not add “{{filename}}” to the knowledge base.",
          unknownError: "Unknown error",
        },
        attachmentUpload: {
          tooLarge: "“{{filename}}” is larger than 20 MB. Upload large files from File Center → Knowledge Base → Retrieval Q&A.",
          unsupportedType: "“{{filename}}” has an unsupported file type: {{type}}",
          unknownType: "Unknown",
        },
        documentModeFeedback: {
          directTaskFailed: "Could not create the direct-generation task.",
          directTaskCreation: "create the direct-generation task",
          taskFailed: "Could not create the document task.",
          taskCreation: "create the document task",
          selectGenreTemplate: "Select a genre template first.",
        },
        versionPicker: {
          current: "Current",
          downloadFailed: "Could not download this version.",
          downloadVersion: "Download v{{version}}",
        },
      },
    },
  },
} as const;
